import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="password"
export default class extends Controller {
  static targets = ["input", "toggleIcon"];

  connect() {
    this.isVisible = false;
  }

  toggle() {
    this.isVisible = !this.isVisible;

    if (this.isVisible) {
      this.inputTarget.type = "text";
      this.updateIcon(true);
    } else {
      this.inputTarget.type = "password";
      this.updateIcon(false);
    }
  }

  updateIcon(isVisible) {
    const icons = this.toggleIconTarget.querySelectorAll("svg");
    if (isVisible) {
      // Show "eye-off" icon (hide password)
      icons[0].classList.add("hidden");
      icons[1].classList.remove("hidden");
    } else {
      // Show "eye" icon (show password)
      icons[0].classList.remove("hidden");
      icons[1].classList.add("hidden");
    }
  }
}

